/** Shared leave day math (Mon–Fri). Matches leave_business_days SQL. */
export function leaveBusinessDays(start: string, end: string, halfDay: boolean): number {
  if (!start || !end) return 0
  const s = new Date(start + 'T12:00:00')
  const e = new Date(end + 'T12:00:00')
  if (e < s) return 0
  if (halfDay && start === end) return 0.5
  let n = 0
  const d = new Date(s)
  while (d <= e) {
    const dow = d.getDay()
    if (dow !== 0 && dow !== 6) n += 1
    d.setDate(d.getDate() + 1)
  }
  return n
}

export function overlapsDates(
  aStart: string,
  aEnd: string,
  bStart: string,
  bEnd: string,
): boolean {
  return aStart <= bEnd && bStart <= aEnd
}

export function formatShortDate(iso: string): string {
  try {
    return new Date(iso + 'T12:00:00').toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    })
  } catch {
    return iso
  }
}

export function daysAgoIso(days: number): string {
  const d = new Date()
  d.setDate(d.getDate() - days)
  return d.toISOString()
}

export function addDaysIso(isoDate: string, days: number): string {
  const d = new Date(isoDate + 'T12:00:00')
  d.setDate(d.getDate() + days)
  return d.toISOString().slice(0, 10)
}

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10)
}
